import React from 'react';

export const Unauthorized = () => {
  return (
    <div className="loader">
      <div className="error-container">
        <div className="message-title">Sorry!</div>
        <div className="message-body">
          <div className="message mt-1">It seems you don&apos;t have permission to access this resource.</div>
          <div className="message">
            {'Please, try again '}
            <a className="message" href="/">
              here
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
